export const DEFAULT_NETWORK_NAME = 'spotim';
export const DEFAULT_NETWORK_ID = 'spotim';
